export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  tone = "dark",
}: {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  tone?: "dark" | "light";
}) {
  const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
  const descCls = tone === "light" ? "text-[#f2e7d0]" : "text-[#8a7a5d]";
  return (
    <div className={`flex flex-col ${alignCls}`}>
      <span
        className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold tracking-[0.15em] ${
          tone === "light"
            ? "border border-[#f2d6a4] text-[#ffd791]"
            : "border border-[#eccf9d] bg-[#fff6e6] text-[#a86a1f]"
        }`}
      >
        <i className="ri-record-circle-line" />
        {eyebrow}
      </span>
      <h2
        className={`font-display mt-4 text-3xl font-black leading-tight md:text-4xl ${
          tone === "light" ? "text-[#fff6e6]" : "text-[#231f18]"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p className={`mt-4 max-w-2xl text-[15px] leading-7 ${descCls}`}>{desc}</p>
      )}
    </div>
  );
}